<template>
  <div class="header">
    <div class="header-icon" @click="goBack()">
      <span class="iconfont icon-fanhui"></span>
    </div>
    <div class="header-title">{{ title }}</div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: () => '',
    },
  },

  methods: {
    goBack() {
      window.history.back(-1);
    }
  }
}
</script>
<style lang="less" scoped>
  .header {
    position: fixed;
    top: 0;
    display: flex;
    width: 100%;
    height: 90px;
    align-items: center;
    font-size: 36px;
    font-weight: bold;
    background: #fff;
    color: #333;
    z-index: 99;

    .header-icon {
      margin-left: 20px;
    }

    .header-title {
      flex: 1;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
</style>
